import React from 'react'
import { ValueEditor as DefaultValueEditor } from 'react-querybuilder';
import Select from 'react-select'

const MultiSelectEditor = ({ value, handleOnChange, fieldData }) =>{
    const options = fieldData?.options || [];

    const handleChange = (selectedOptions) => {
        handleOnChange(selectedOptions.map((opt) => opt.value));
      };
    
    const selectedValues = options.filter((opt) => value?.includes(opt.value));

    const customStyles = {
        container: provided => ({
          ...provided,
          width: 500
        })
      };

    return(
        <Select
            styles={customStyles}
            isMulti
            options={options}
            value={selectedValues}
            onChange={handleChange}
            closeMenuOnSelect={false}            
        />
    )
};

const MultiValueEditor = (props) => {
    const { fieldData } = props;

    if (fieldData?.valueEditorType === 'multiselect'){
        return <MultiSelectEditor {...props} />
    }

    return <DefaultValueEditor {...props} />;
}

export default MultiValueEditor;